module.exports = __webpack_public_path__ + "img/featureSlide01ImgMo.57a7ae44.png";